export default (_, props) => props;
